var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddButton = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(-1374 -360)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 53,
    height: 53,
    rx: 14,
    transform: "translate(1374 360)",
    fill: "#35B6BC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boton-agregar_1_",
    "data-name": "boton-agregar (1)",
    transform: "translate(1379 365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M21.5,11A10.5,10.5,0,1,0,32,21.5,10.512,10.512,0,0,0,21.5,11Zm0,19.252A8.752,8.752,0,1,1,30.252,21.5,8.761,8.761,0,0,1,21.5,30.252Z",
    transform: "translate(-11 -11)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M143.583,138.354H140.1v-3.48a.874.874,0,0,0-1.749,0v3.48h-3.48a.874.874,0,0,0,0,1.749h3.48v3.48a.874.874,0,0,0,1.749,0V140.1h3.48a.874.874,0,1,0,0-1.749Z",
    transform: "translate(-128.729 -128.728)",
    fill: "#fafafa"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-button.39cd8413.svg";
export { ForwardRef as ReactComponent };